import { Container } from "@mui/material";
import { ImageCheck, LoadingSimpleComponent, CollaborationLink } from "Explore/Components";
import {
  ImageCheckType,
  ImageType,
  SkeletonType,
} from "Explore/Config/ImageType";
import styles from "./BasicInformation.module.scss";
import useDeviceCheck from "Hooks/useDeviceCheck";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Modal } from "antd";

const BasicInformation = ({ unit_id, institution_id, summary }) => {
  const { isMobile } = useDeviceCheck();
  const { landscapeBackground } = useSelector((state) => state.commonState);
  const navigate = useNavigate();
  const [seeMore, setSeeMore] = useState(false);
  const bio = summary?.data?.biography || summary?.data?.description || "";

  const renderAvatar = () => {
    return (
      <LoadingSimpleComponent
        component={
          <ImageCheck
            url={`https://media.academic.online/institutions_images/${institution_id}/${ImageType.SEAL}.png`}
            className={styles["images-seal"]}
            alt={"seal"}
            type={ImageCheckType.INSTITUTION_LOGO}
          />
        }
        type={SkeletonType.IMAGE}
        isLoading={summary.isLoading}
        className={styles["images-seal-wrapper"]}
      />
    );
  };

  if (summary.isLoading) {
    return (
      <div className={styles["basic-information"]}>
        <LoadingSimpleComponent
          type={SkeletonType.PARAGRAPH}
          isLoading={true}
          className={styles["cover-img-wrapper"]}
          rows={12}
        />
      </div>
    );
  }

  return (
    <>
      <div className={styles["basic-information"]}>
        <div className={styles["basic-information__left"]}>
          <LoadingSimpleComponent
            component={
              <ImageCheck
                url={landscapeBackground}
                className={styles["cover-img"]}
                type={ImageCheckType.INSTITUTION_LANDSCAPE}
              />
            }
            type={SkeletonType.COVER_IMAGE}
            isLoading={summary.isLoading}
            className={styles["cover-img-wrapper"]}
          />
        </div>
        <div className={styles["basic-information__right"]}>
          <Container maxWidth="lg">
            {renderAvatar()}
            <LoadingSimpleComponent
              component={
                <h1 className={styles["name"]}>{summary?.data.name}</h1>
              }
              type={SkeletonType.INPUT}
              isLoading={summary.isLoading}
              className={styles["name"]}
            />
            <LoadingSimpleComponent
              component={<p onClick={() => navigate(`/explore/institution/${summary?.data.institution_explore_slug || summary?.data.institution_id}`)}>{summary?.data.institution_name}</p>}
              type={SkeletonType.INPUT}
              isLoading={summary.isLoading}
              className={styles["sub-name"]}
            />
            {bio && (
              <div className={styles["bio"]}>
                <p
                  className={styles["bio--content"]}
                  onClick={() => setSeeMore(true)}
                >
                  {bio}
                </p>
              </div>
            )}
            {(() => {
              const canonicalId = summary?.data?.id || unit_id;
              const instId = summary?.data?.institution_id || institution_id;
              const isNumericInstId = instId && !isNaN(Number(instId));
              const unitLogo =
                summary?.data?.photo ||
                summary?.data?.logo_url ||
                (isNumericInstId
                  ? `https://media.academic.online/institutions_images/${instId}/seal.png`
                  : undefined);
              return (
                <div className={styles["more-info"]}>
                  <CollaborationLink
                    entity={{
                      id: canonicalId,
                      name: summary?.data?.name || summary?.data?.display_name,
                      type: "unit",
                      photo: unitLogo,
                      avatar: unitLogo,
                      institution_id: instId,
                      institution_name: summary?.data?.institution_name,
                    }}
                  />
                </div>
              );
            })()}
          </Container>
        </div>
      </div>

      <Modal
        title="About"
        onCancel={() => setSeeMore(false)}
        open={seeMore}
        footer={null}
      >
        <p>{bio}</p>
      </Modal>
    </>
  );
};

export default BasicInformation;

